import React from "react";
import "./ViewPostReview.scss";
import Image from "../../../components/ui/image/Image";
import { AppIcons } from "../../../data/appIcons";

const ViewPostReview = () => {
  return (
    <div className="view-postreview-sec">
      <div className="row">
        <div className="image-part col-7">
          <Image imagePath={AppIcons.logoImage} />
        </div>
        <div className="title col-5">
          <h4>SGTech hosts the world's first global forum on Digital Teust</h4>
        </div>
      </div>
      <div className="content-part">
        <h4 className="content-title">
          SGTech hosts the world’s first global forum on Digital Trust
        </h4>
        <p className="date">Published October 2022</p>
        <p>
          The premier trade association also launched Singapore’s first Digital
          Trust Centre of Excellence to forge a path towards making the nation a
          global leader in Digital Trust
        </p>
        <p>
          Singapore – 28 October 2022 — SGTech, the premier trade association
          for the tech industry in Singapore, today hosted the world’s first
          global forum on Digital Trust at Resorts World Sentosa Convention
          Centre, Singapore. Entitled ‘SGTech Global Future Series: Digital
          Trust Forum’, the event brought together global leaders,
          practitioners, and thinkers to discuss the current landscape,
          challenges, opportunities, and actionable ideas for Singapore to work
          towards being a global digital and data node.
        </p>
        <p>
          The forum featured more than 30 global luminaries and thinkers on
          Digital Trust, such as Senior Minister of State for Communications and
          Information Tan Kiat How, Dr Bhaskar Chakravorti (Dean of Global
          Business at The Fletcher School at Tufts University), Piyush Gupta
          (Chief Executive Officer, DBS Group), Ajay Bhalla (President, Cyber &
          Intelligence, Mastercard) and Janet De Silva (President and Chief
          Executive Officer of the Toronto Region Board of Trade, and Chair of
          the Digital Working Group, APEC Business Advisory Council), among many
          more.
        </p>
        <p>
          SGTech Chair Mr Wong Wai Meng, said: “SGTech believes that Digital
          Trust will be a game-changer for Singapore to secure its place as a
          global digital and data node. To fully capitalise on this opportunity
          will require an acceleration in our capabilities building and skills
          development that demands the collective will and vision of our
          government, businesses, and individuals. Our aim is to provide early
          thinking and chart a game plan for the community to drive, and
          collectively position Singapore as a Global Digital & Data node built
          on trust. Thereby securing Singapore’s future in the Digital economy.”
        </p>
        <p>
          The global forum held today was one of the initiatives driven by
          SGTech’s Digital Trust Committee. The first was SGTech’s recent launch
          of its landscape study on Digital Trust, which detailed how Singapore
          could grow the sector to S$4.8 billion in 2027. Launched on Thursday,
          20 October 2022, the white paper revealed eight business areas that
          will drive the rapid growth of the sector, namely Cybersecurity,
          Digital Trust Consulting, Digital Identity, Certifications,
          Governance, Risk and Compliance (GRC) solutions, Cyber Insurance,
          Distributed Ledgers Technology (DLT) and Privacy Enhancing
          Technologies (PET). Speakers at today’s Forum shed light on these
          areas through the 16 unique programme sessions of the event.
        </p>
      </div>
    </div>
  );
};

export default ViewPostReview;
